import { render } from "./itemTime.vue?vue&type=template&id=dbf0fa80&scoped=true"
import script from "./itemTime.vue?vue&type=script&lang=js"
export * from "./itemTime.vue?vue&type=script&lang=js"

import "./itemTime.vue?vue&type=style&index=0&id=dbf0fa80&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbf0fa80"]])

export default __exports__